import { DataBean } from "../DataBean";

export class DistributionChannel extends DataBean {



    public async deleteDistributionChannel(idDistributionChannel: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteDistributionChannel_Number", [idDistributionChannel]);
    }
    public async addDistributionChannelByAccount(idAccount: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.sales.DistributionChannel_addDistributionChannelByAccount_Number", [idAccount]);
    }
    public async getDistributionChannelCatalog(idAccount: any, regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getDistributionChannelCatalog_Number_String_Number_Number", [idAccount, regexStr, page, recordsPerPage]);
    }

}